export { default } from "./DecodableBadge";
